import { Controller } from '@stimulus/core';
export default class extends Controller {
    // connect() {
    // }
    // disconnect() {
    // }
    submit(evt) {
        evt.preventDefault();
        const link = this.element;
        const params = [
            ['不具合のあったURL', window.location.href],
            ['ご利用環境', navigator.userAgent],
            ['ログインID', this.data.get('login')],
        ]
            .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
            .join('&');
        const url = link.href + '?' + params;
        window.open(url, '_blank');
    }
}
